"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function EventDjAndReservations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="eventdjandreservations" className="relative bg-background px-6 py-12 md:px-16 md:py-20" ref={ref}>
      {}
      <div className="absolute inset-0 bg-primary/5 pointer-events-none" />
      
      <div className="container relative z-10 mx-auto flex flex-col items-center justify-center">
        <Card className={`max-w-3xl w-full mx-auto transition-all duration-700 shadow-clay border-none bg-white/95 backdrop-blur-sm ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <CardHeader className="text-center pt-8 px-4 md:px-6">
            <CardTitle className="text-2xl md:text-3xl text-primary font-display">
              DJ и Резервации за Вашите Събития
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 md:space-y-6 pb-8 px-4 md:px-6">
            <div className="space-y-4">
              <div className="text-center">
                <h4 className="text-lg md:text-[22px] text-primary-active mb-2">Музикално Оформление</h4>
                <p className="text-sm md:text-lg leading-relaxed text-foreground">
                  В заведението ни имаме на разположение DJ за вашите събития, който ще създаде перфектната атмосфера и ще направи празника ви незабравим с разнообразна музика според вашите предпочитания.
                </p>
              </div>
              
              <div className="text-center">
                <h4 className="text-lg md:text-[22px] text-primary-active mb-2">Време за Резервации</h4>
                <p className="text-sm md:text-lg leading-relaxed text-foreground">
                  През седмицата приемаме резервации за събития след 18:00 часа, а в събота и неделя можете да резервирате по всяко време, което ви е удобно.
                </p>
              </div>
            </div>

            
          </CardContent>
        </Card>
      </div>
    </section>;
}